import { render, staticRenderFns } from "./NatConVicePresidentAwardList.vue?vue&type=template&id=32c1bdc6"
import script from "./NatConVicePresidentAwardList.vue?vue&type=script&lang=js"
export * from "./NatConVicePresidentAwardList.vue?vue&type=script&lang=js"
import style0 from "./NatConVicePresidentAwardList.vue?vue&type=style&index=0&id=32c1bdc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports